import {Injectable} from '@angular/core';
import {forkJoin} from 'rxjs';
import {NICESkillAgent} from '../models/NICE_SkillAgent.model';
import {GeneralService} from './general.service';
import {AuthService} from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class IcDataSkillService {
    private url: string;
    private dataJSON: string;
    private modData: any[];
    private addData: any[];
    private delData: any[];

    constructor(
        public genHttp: GeneralService,
        public auth: AuthService
    ) {
    }

    public updateSkillWithUsers(originalData: NICESkillAgent[], newSkillUser: NICESkillAgent[], skill2Assign: string): Promise<any> {

        return new Promise((resolve, reject) => {
            this.modData = [];
            this.addData = [];
            this.delData = [];
            for (const orig of originalData) {
                let found = false;
                for (const newA of newSkillUser) {
                    if (orig.agentId === newA.agentId) {
                        found = true;
                        this.modData.push({
                            agentId: newA.agentId.toString(),
                            proficiency: newA.agentProficiencyValue,
                            isActive: newA.isActive
                        });
                        break;
                    }
                }
                if (!found) {
                    this.delData.push({agentId: orig.agentId.toString()});
                }
            }
            for (const newA of newSkillUser) {
                let found = false;
                for (const orig of originalData) {
                    if (orig.agentId === newA.agentId) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.addData.push({
                        agentId: newA.agentId.toString(),
                        proficiency: newA.agentProficiencyValue,
                        isActive: newA.isActive
                    });
                }
            }
            const source = forkJoin({
                del: this.deleteSkillAgents(skill2Assign, this.delData),
                add: this.addSkillAgents(skill2Assign, this.addData),
                mod: this.updateSkillAgents(skill2Assign, this.modData)
            });
            source.subscribe((res) => {
                resolve(res);
            }, reject);

        });
    }

    public updateSkillAgents(skillId: string, data: any): Promise<any> {
        this.url = 'baseURL/services/' + this.auth.apiVersion + '/skills/' + skillId + '/agents';
        this.dataJSON = '{"agents":' + JSON.stringify(data) + '}';
        return new Promise((resolve, reject) => {
            if (data.length !== 0) {
                this.genHttp.icPut(this.url, this.dataJSON).subscribe((response: any) => {
                    resolve(response);
                }, reject);
            } else {
                resolve(true);
            }
        });
    }

    public deleteSkillAgents(skillId: string, data: any): Promise<any> {
        this.url = 'baseURL/services/' + this.auth.apiVersion + '/skills/' + skillId + '/agents';
        this.dataJSON = '{"agents":' + JSON.stringify(data) + '}';
        return new Promise((resolve, reject) => {
            if (data.length !== 0) {
                this.genHttp.icDelete(this.url, this.dataJSON).subscribe((response: any) => {
                    resolve(response);
                }, reject);
            } else {
                resolve(true);
            }
        });
    }

    public addSkillAgents(skillId: string, data: any): Promise<any> {
        this.url = 'baseURL/services/' + this.auth.apiVersion + '/skills/' + skillId + '/agents';
        this.dataJSON = '{"agents":' + JSON.stringify(data) + '}';
        return new Promise((resolve, reject) => {
            if (data.length !== 0) {
                this.genHttp.icPost(this.url, this.dataJSON).subscribe((response: any) => {
                    resolve(response);
                }, reject);
            } else {
                resolve(true);
            }
        });
    }


}
